import React, { Component } from "react";
import { connect } from "react-redux";
import { Tag } from "antd";

import { ORG_CODE } from "../../utils/contrains";
import { req_single_ucan_token_get } from "../../api";
import { formateDate } from "../../utils/dateUtil";

class UcanSsoLink extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    loading: false,
    ssourl: null,
    currentTime: formateDate(Date.now()),
    startTime: Date.now(),
    timeElapsed: 0,
    timeOver: 5,
    workingTime: 1,
  };

  componentDidMount() {
    this.ucan_sso_process();
    this.getTime();
  }

  componentWillUnmount() {
    // 有定時器時要移除
    clearInterval(this.intervalId);
  }

  // 數據格式處理 //////////////////////////////////////////////

  ucan_sso_process = async () => {
    const originalUrl = "https://ucan.moe.edu.tw/";
    const { userCode } = this.props.user;
    const key = ORG_CODE + userCode.replace(/\s+/g, "").toUpperCase();
    const token = await req_single_ucan_token_get(ORG_CODE, key);
    console.log('token',token)
    const ssourl =
      token === "NA"
        ? originalUrl
        : "https://ucan.moe.edu.tw/bin/index.php?Plugin=o_hdu&Action=ohduschoolssologin&username=" +
          key +
          "&school=" +
          ORG_CODE +
          "&token=" +
          token;
    this.setState({ ssourl });
  };

  getTime = () => {
    this.intervalId = setInterval(() => {
      const currentTime = formateDate(Date.now());
      this.setState({ currentTime });

      const runTime = new Date();
      const timeElapsed = Math.floor((runTime - this.state.startTime) / 1000);

      this.setState({ timeElapsed: timeElapsed });

      if (this.state.timeElapsed >= this.state.workingTime * 1) {
        clearInterval(this.intervalId);
        this.refresh();
      }
    }, 1000);
  };

  refresh() {
    window.location.replace(this.state.ssourl);
  }

  /////////////////////////////////////////////////////////////
  render() {
    const { timeElapsed } = this.state;
    // const { ssourl, timeElapsed } = this.state
    // const originalUrl = ssourl
    // const notest = (<div className="alert alert-danger" role="alert"><a href={originalUrl} target="_blank" className="btn btn-mdanger" rel="noreferrer" role="button"><Button type="primary" shape="round" size="small"> 按我 <i className="fas fa-mouse-pointer" style={{ marginLeft: '4px' }}></i></Button> 5秒自動跳轉至UCAN平台 (註：今日測驗/明日解析)，計時 <Tag color="magenta">{timeElapsed}</Tag>秒</a></div>)
    const notest = (
      <div className="alert alert-danger" role="alert">
        1秒自動跳轉至UCAN平台 (註：今日測驗/明日解析)，計時{" "}
        <Tag color="magenta">{timeElapsed}</Tag>秒
      </div>
    );

    return <>{notest}</>;
  }
}

export default connect((state) => ({ user: state.user }), {})(UcanSsoLink);
